define(["exports", "./pubsubhub"], function (_exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.done = _exports.name = void 0;
  // @ts-check

  /**
   * Module core/pre-process
   *
   * Corresponds to respecConfig.preProcess.
   *  - preProcess: an array of functions that get called
   *      before anything else happens. This is not recommended and the feature is not
   *      tested. Use with care, if you know what you're doing. Chances are you really
   *      want to be using a new module with your own profile
   */
  const name = "core/pre-process";
  _exports.name = name;
  let doneResolver;
  const done = new Promise(resolve => {
    doneResolver = resolve;
  });
  _exports.done = done;
  (0, _pubsubhub.sub)("start-all", async config => {
    const result = [];

    if (Array.isArray(config.preProcess)) {
      const promises = config.preProcess.filter(f => {
        const isFunction = typeof f === "function";

        if (!isFunction) {
          (0, _pubsubhub.pub)("error", "Every item in `preProcess` must be a JS function.");
        }

        return isFunction;
      }).map(async f => {
        try {
          return await f(config, document);
        } catch (err) {
          (0, _pubsubhub.pub)("error", "Function ".concat(f.name, " threw an error during `preProcess`. See developer console."));
          console.error(err);
        }
      });
      const values = await Promise.all(promises);
      result.push(...values);
    }

    doneResolver(result);
  }, {
    once: true
  });
});
//# sourceMappingURL=pre-process.js.map